import gql from 'graphql-tag';

export const GET_TREADWELL_GEN_AI = gql`
  query treadwellGenAI($productInfo: [ProductInfoInput]!, $requestType: RequestTypeEnum!, $sourceType: SourceTypeEnum!, $storeCode: String!, $treadwellRequest: TreadwellRequest, $vehicleInfo: VehicleInput, $treadwellCacheKey: String!) {
  product{
      treadwellGenAI(treadwellRequest: $treadwellRequest, requestType: $requestType, sourceType: $sourceType, treadwellCacheKey: $treadwellCacheKey, vehicleInfo: $vehicleInfo, productInfo: $productInfo, storeCode: $storeCode)        
    }
  }
`;
